module.exports = __webpack_public_path__ + "static/img/28_.b3e418d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/28_.jpg
// module id = ky/x
// module chunks = 1